import { useEffect, useRef } from 'react';

const useBlockInteraction = (isBlocked) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!isBlocked) {
      return undefined;
    }

    // Remove focus from any active field inside the blocked container.
    const { activeElement } = document;
    const container = containerRef.current;
    if (container && activeElement instanceof HTMLElement && container.contains(activeElement)) {
      activeElement.blur();
    }

    // Capture keydown globally so background controls do not receive keyboard input.
    const suppressKeyboardInteraction = (event) => {
      event.preventDefault();
    };

    document.addEventListener('keydown', suppressKeyboardInteraction, true);

    return () => {
      // Restore keyboard behavior once interaction is unblocked.
      document.removeEventListener('keydown', suppressKeyboardInteraction, true);
    };
  }, [isBlocked]);

  return containerRef;
};

export default useBlockInteraction;
